import { render } from "./GoodsListCate3.vue?vue&type=template&id=6456fad4"
import script from "./GoodsListCate3.vue?vue&type=script&lang=js"
export * from "./GoodsListCate3.vue?vue&type=script&lang=js"

import "./GoodsListCate3.vue?vue&type=style&index=0&id=6456fad4&lang=scss"

import exportComponent from "D:\\部署项目\\电商\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__